import script from "./ModalConfirmDeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirmDeleteAccount.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirmDeleteAccount.vue?vue&type=style&index=0&id=7b0ea20a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0ea20a"]])

export default __exports__